import { api } from '@marketplace-web/core-api/core-api-client-util'

import { GetPublicPhotosResp, GetPublicPhotosArgs } from '../types/public-photos'

export const getPublicPhotos = ({ itemIds, photoSize }: GetPublicPhotosArgs) =>
  api.get<GetPublicPhotosResp>('/items/public_photos', {
    params: {
      item_ids: itemIds,
      photo_size: photoSize,
    },
  })
